import React from 'react';
import {
    List,
    Datagrid,
    TextField,
    DateField,
    EditButton,
    BooleanField
} from 'react-admin';

// own ui
import CustomFilterTextThemeActive from '../../ui/custom-filter-text-theme-active';
import CustomImageField from '../../ui/custom-image-field';
import ThemeCuriosityExporter from '../../exporter/theme-curiosity-exporter';

const ThemeCuriosityList = (props) => (
    <List
      title="Curiosidades" {...props}
      sort={{ field: 'id', order: 'desc' }}
      filters={ <CustomFilterTextThemeActive /> }
      filterDefaultValues={{ active: true }}
      bulkActionButtons={ false }
      exporter={ ThemeCuriosityExporter } >
        <Datagrid
          rowClick="show">
          <TextField source="id" sortable={true} />
          <CustomImageField source="image_cover" label="Imagem" sortable={false}/>
          <TextField source="theme_name" label="Tema" sortable={false} />
          <TextField source="title.pt_br" label="Título" sortable={false} />
          <TextField source="city_name" label="Cidade" sortable={false} />
          <BooleanField source="active" label="Ativo" sortable={false} />
          <DateField source="created_at" locales="pt-BR" label="Criado em" sortable={false} />
          <EditButton />
        </Datagrid>
    </List>
);

export default ThemeCuriosityList;
